import { __awaiter, __generator } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import { config } from '../config';
import { useDispatch, useSelector } from 'react-redux';
import { getThreadId } from '../../domain/selectors/get-thread-id';
import { createDebugLogger } from '../utils/app-utils';
import { remoteLog } from '../../../_library/utils/remote-log';
import { useDeviceAndSiteStatus } from '../utils/network-utils';
import { getClientConfig } from '../utils/app-storage';
import { dispatchIsOnline } from '../../domain/arbitrary-helpers';
import { chatAction } from '../../chat/chat-redux';
var debug = createDebugLogger('ConnectivityCheck');
var cfg = getClientConfig();
var logOfflineDuration = function (dateFrom, threadId) {
    if (!dateFrom)
        return;
    var offlineDuration = Math.floor((new Date().getTime() - dateFrom.getTime()) / 1000);
    var offlineStart = dateFrom.toISOString();
    var msg = "Connectivity restored after ".concat(offlineDuration, "s, start: ").concat(offlineStart);
    remoteLog.info(msg, threadId).then().catch();
};
export var ConnectivityCheck = function () {
    var threadId = useSelector(getThreadId);
    var dispatch = useDispatch();
    var _a = useState(true), isOnline = _a[0], setIsOnline = _a[1];
    var _b = useState(false), showOfflineMessage = _b[0], setShowOfflineMessage = _b[1];
    var offlineEventTime = useRef(null);
    var isThreadActive = !!threadId;
    var connectivityCheckUrl = cfg.CHAT_API.URL; // url of api server
    var wasOffline = useRef(false);
    var hasClientConnectivity = useDeviceAndSiteStatus({
        url: connectivityCheckUrl,
        skipReachableCheck: !isThreadActive, // skip check if thread is not active
    });
    useEffect(function () {
        var handleOnlineStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!wasOffline.current)
                    return [2 /*return*/]; // do not handle online status if we were not offline
                debug('Handle Online Status');
                dispatchIsOnline(dispatch, true);
                setIsOnline(true);
                try {
                    setShowOfflineMessage(false); // hide offline message after messages fetched successfully
                    logOfflineDuration(offlineEventTime.current, threadId);
                }
                catch (e) {
                    remoteLog
                        .error("Error fetching chat messages: ".concat(e.message), threadId)
                        .catch();
                }
                // reload all messages - this fetches the messages that were not delivered when offline
                dispatch(chatAction.readThread(null, threadId));
                wasOffline.current = false;
                return [2 /*return*/];
            });
        }); };
        var handleOfflineStatus = function () {
            debug('Handle Offline Status');
            dispatchIsOnline(dispatch, false);
            setShowOfflineMessage(true);
            setIsOnline(false);
            wasOffline.current = true;
            offlineEventTime.current = new Date();
        };
        if (hasClientConnectivity) {
            handleOnlineStatus().catch(function (error) {
                debug("Error handling online status: ".concat(error.message));
                remoteLog
                    .error("Error handling online status: ".concat(error.message), threadId)
                    .catch();
            });
        }
        else {
            handleOfflineStatus();
        }
    }, [threadId, hasClientConnectivity]);
    var message = 'Skontrolujte prosím pripojenie k internetu.';
    var reloadText = 'Obnoviť';
    if (showOfflineMessage) {
        return (React.createElement("div", { className: config.css.B('-connectivity-check') },
            React.createElement("span", { className: "".concat(config.css.B('-connectivity-check__message')) }, message),
            isOnline && (React.createElement("button", { onClick: function () {
                    window.location.reload();
                }, className: "".concat(config.css.B('-connectivity-check__button')) }, reloadText))));
    }
    else {
        return null;
    }
};
